import { CellProps, Renderer } from 'react-table'
import React from 'react'

export const ValueCell: Renderer<CellProps<Record<string, unknown>, string>> = ({ value }) => {
  return <>{value}</>
}
